export default "__VITE_ASSET__BbPNz5n___"